import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgCalendarSmall(props: ISvgProps) {
	return (
		<svg width={61} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#CalendarSmall_svg__a)">
				<g clipPath="url(#CalendarSmall_svg__b)">
					<path
						d="M6.956 59.687h44.173c3.495 0 6.396-2.864 6.396-6.38V11.224c0-3.516-2.9-6.354-6.396-6.354h-6.292V1.484c0-.65-.518-1.172-1.165-1.172s-1.165.521-1.165 1.172V4.87H15.578V1.484c0-.65-.518-1.172-1.165-1.172s-1.165.521-1.165 1.172V4.87H6.956C3.46 4.87.56 7.708.56 11.224v42.083c0 3.516 2.9 6.38 6.396 6.38Zm44.173-2.343H6.956c-2.214 0-4.066-1.81-4.066-4.037V20.755h52.304v32.552c0 2.227-1.852 4.037-4.065 4.037ZM6.956 7.214h6.292v3.333c0 .651.517 1.172 1.165 1.172.647 0 1.165-.521 1.165-1.172V7.214h26.928v3.333c0 .651.518 1.172 1.166 1.172.647 0 1.165-.521 1.165-1.172V7.214h6.292c2.214 0 4.065 1.783 4.065 4.01v7.187H2.89v-7.187c0-2.227 1.85-4.01 4.065-4.01Z"
						fill={props.primaryColor}
					/>
					<rect x={7.168} y={24.667} width={9.28} height={6} rx={3} fill={props.secondaryColor} />
				</g>
			</g>
			<defs>
				<clipPath id="CalendarSmall_svg__a">
					<path fill="#fff" transform="translate(.042)" d="M0 0h60v60H0z" />
				</clipPath>
				<clipPath id="CalendarSmall_svg__b">
					<path fill="#fff" transform="translate(.042)" d="M0 0h58v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgCalendarSmall;
